<div class="product-notifications">
  <h1>{{ 'account.notifications.heading' | translate }}</h1>

  <!-- Error message -->
  <ish-error-message [error]="productNotificationsError$ | async" />

  <ul ngbNav class="nav-tabs" [(activeId)]="active">
    <li ngbNavItem="price" role="presentation">
      <a
        ngbNavLink
        [routerLink]="['../notifications', { notificationType: 'price' }]"
        data-testing-id="tab-link-notifications-price"
        >{{ 'account.notifications.price.heading' | translate }}</a
      >
    </li>
    <li ngbNavItem="stock" role="presentation">
      <a
        ngbNavLink
        [routerLink]="['../notifications', { notificationType: 'stock' }]"
        data-testing-id="tab-link-notifications-instock"
        >{{ 'account.notifications.backinstock.heading' | translate }}</a
      >
    </li>
  </ul>

  <div class="section">
    <ish-account-product-notifications-list [productNotifications]="productNotifications$ | async" />
  </div>
</div>

<ish-loading *ngIf="productNotificationsLoading$ | async" />
